import React from 'react';

import { Heading } from '../../Common/Heading';
import { SectionContent } from './SectionContent';

export const WifiHub = () => {
  return (
    <SectionContent>
      <Heading>WIFI hub</Heading>
    </SectionContent>
  );
};
